import React, { Component } from 'react';
import cn from 'classnames';
import styles from './FormPasswordRestore.scss';

import Button from '../../common/Button/Button';
import Spinner from '../../common/Spinner/Spinner';

class FormPasswordRestore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: false,
      isButtonActive: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleInputChange(event) {
    this.setState({ email: event.target.value, error: false }, () => {
      if (this.state.email.length > 10) {
        this.setState({ isButtonActive: true });
      } else {
        this.setState({ isButtonActive: false });
      }
    });
  }

  handleButtonClick() {
    if (this.state.isButtonActive) {
      this.props.numberFormSending(this.state.email);
      this.setState({ isButtonActive: false, error: true });
    }
  }

  render() {
    const { className } = this.props;

    return (
      <div className={cn(styles.FormPasswordRestore, className)}>

        <div className={styles.FormInner}>
          <div className={styles.Logo}>
            NEDVEX
          </div>
          { !this.state.error ?
            <div className={styles.Label}>
              Введите адрес электронной почты
            </div> :
            <div className={styles.LabelErr}>
              Электронная почта отсуствует в базе
            </div>
          }


          { !this.props.otherForms.isLoading ?
            <div>
              <div className={styles.Input}>
                <input
                  type="text"
                  maxLength="20"
                  placeholder="mail@example.com"
                  value={this.state.email}
                  onChange={this.handleInputChange}
                />
              </div>
              <Button className={cn(styles.Button, this.state.isButtonActive ? styles.ButtonActive : '')} onClick={this.handleButtonClick}>Продолжить</Button>
            </div> :
            <div className={styles.Spinner}>
              <Spinner />
            </div> }
          <div className={styles.Footer}>
            <Button className={styles.Blue}>Нет приглашения?</Button>
            <Button className={styles.Blue}>Авторизация</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default FormPasswordRestore;



// WEBPACK FOOTER //
// ./src/components/Login/FormPasswordRestore/FormPasswordRestore.js